import { render, staticRenderFns } from "./document-modal.vue?vue&type=template&id=faeb39e6&scoped=true"
import script from "./document-modal.vue?vue&type=script&lang=js"
export * from "./document-modal.vue?vue&type=script&lang=js"
import style0 from "./document-modal.vue?vue&type=style&index=0&id=faeb39e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faeb39e6",
  null
  
)

export default component.exports